/**
 * 这个文件作为组件的目录
 * 목적은统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import OrderStatusCountCard from './OrderStatusCountCard';
import AnimatedCount from './AnimatedCount';
import WarehouseReceiptModal from './WarehouseReceiptModal';
import PickingModal from './PickingModal';

export { 
  AvatarDropdown, 
  AvatarName, 
  Footer, 
  Question, 
  SelectLang, 
  OrderStatusCountCard, 
  AnimatedCount,
  WarehouseReceiptModal,
  PickingModal,
};
